import * as Route from '../utils/serverRoutes';
import {
  transformResponseCollection,
  updateCollectionById,
  payloadToData,
} from '../utils/helpers';
import makeRequest from '../utils/makeRequest';

const cost = {
  state: {
    collection: [],
    uploading: false,
  },
  reducers: {
    fetchCostsReducer(state, { collection }) {
      return { ...state, collection };
    },
    addCostReducer(state, payload) {
      return { ...state, collection: [...state.collection, payload] };
    },
    updateCostReducer(state, payload) {
      const res = {
        ...state,
        collection: updateCollectionById(state.collection, payload.id, payload),
      };

      return res;
    },
    removeCostReducer(state, { id }) {
      const collection = state.collection.filter((e) => e.id !== id);

      return { ...state, collection };
    },
    updateAttributeReducer(state, payload) {
      return { ...state, ...payload };
    },
  },
  effects: (dispatch) => ({
    async fetchCosts(bmcId) {
      dispatch.cost.updateAttributeReducer({ uploading: true });

      makeRequest({
        dispatch,
        url: Route.costs(bmcId),
        success: (response) => {
          dispatch.cost.fetchCostsReducer({
            collection: transformResponseCollection(response.data.data),
          });
        },
        finish: () => {
          dispatch.cost.updateAttributeReducer({ uploading: false });
        },
      });
    },

    async addCost(_, state) {
      makeRequest({
        dispatch,
        method: 'post',
        url: Route.costs(state.bmc.current.id),
      });
    },

    async updateCost(payload, state) {
      const transformedCostPayload = {
        ...payload,
      };

      if (payload.name === 'amount') {
        // payload is of type:  {amount: number, id: number, valueIndex: number}
        // the amount is an array of numbers
        // we need to extract only the amount and transform it to an array based on what we have in the state and feed this amount value and the id to the updateCollectionById function
        const thisCostItem = state.cost.collection.find(
          (e) => e.id === payload.id,
        );

        let thisCostItemAmountArray = thisCostItem?.amount ?? [];

        // we need to check whether the valueIndex we are trying to update is present in the array (the array may be shorter)
        // if not present then we need to fill in the gaps in the array with 0
        // otherwise just update
        if (thisCostItemAmountArray.length < payload.valueIndex) {
          // keep the array as is and fill in the gaps with 0
          thisCostItemAmountArray = thisCostItemAmountArray.concat(
            Array(payload.valueIndex - thisCostItemAmountArray.length).fill(0),
          );
        }

        thisCostItemAmountArray[payload.valueIndex] = payload.value;

        transformedCostPayload.value = thisCostItemAmountArray;

        // if reset flag present then we set everything to 0
        if (payload.reset) {
          transformedCostPayload.value = Array(
            thisCostItemAmountArray.length,
          ).fill(0);
        }
      }

      const data = payloadToData(transformedCostPayload);
      dispatch.cost.updateCostReducer(data);

      makeRequest({
        dispatch,
        method: 'put',
        url: Route.cost(state.bmc.current.id, payload.id),
        data: { cost: data },
      });
    },

    async removeCost(payload, state) {
      makeRequest({
        dispatch,
        method: 'delete',
        url: Route.cost(state.bmc.current.id, payload.id),
      });
    },
  }),
};

export default cost;
